import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { FC } from "react";

interface IDeleteJobModal {
    open: boolean;
    onDeleteJob: (jobNumber: string, operation: string) => void;
    onClose: () => void;
    jobNumber: string;
    operation: string;
  }

  export const DeleteJobModal: FC<IDeleteJobModal> = ({
    open,
    onDeleteJob,
    onClose,
    jobNumber,
    operation,
  }) => {
    const dialogHeader = "CSM Shopfloor";
  
    const buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
            onDeleteJob(jobNumber, operation);
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
        },
        click: () => {
          onClose();
        },
      },
    ];
  
    const firstPosition = { X: 400, Y: 200 };
  
    return (
      <DialogComponent
        width="400px"
        close={onClose}
        header={dialogHeader}
        visible={open}
        showCloseIcon={true}
        buttons={buttons}
        position={firstPosition}
        isModal
      >
        The operation was logged less then 30 seconds. Do you want to delete it?
      </DialogComponent>
    );
  };
  